import React, { Component } from 'react';
import "./public.css"
import Publicnav from "./publicNav.js"
import Publicleft from "./publicleft.js"
import Publicright from "./publicright"
import PublicData from "./publicData.js"
import "react-responsive-carousel/lib/styles/carousel.min.css";
import { Carousel } from 'react-responsive-carousel';
import {
  
    Redirect
  } from 'react-router-dom'
class Public extends Component {
   
    constructor(props){
        super(props)  
        this.state ={
            pamaschange : "",
            public :[],
            payments:[],
            notification:[],
            check : false,
            loading :false,
            noerorrpage :  true,
            showList: false,
            value: [],
            image :"https://cf-images.eu-west-1.prod.boltdns.net/v1/static/624246174001/71783484-3712-4c9a-93ea-ca05f4221b31/440d85db-2e69-430d-9776-9c92494250ba/1280x720/match/image.jpg"
        }
    }

    componentDidMount(){
        
        
        this.props.noerorrpage(this.state.noerorrpage)
        const { match: { params } } = this.props;
    //  console.log("params.userId",params.id, "params all", params)
                this.setState({
                    pamaschange : params.id
                })
   
       
               this.setState({
                   noticepop : false,
                   loadingnews :true
               })
               console.log("public users id", this.state.pamaschange)
               // console.log("get payment",  Auth.getProfile().userId)
               const requestOptions = {
                   method: 'GET', 
                   headers: { 'Content-Type':'application/json','Access-Control-Allow-Origin': '*'  },
               };
               this.setState({
                loading:true
               })
               console.log("public users param", params.id)
               fetch("https://uvunebeta.herokuapp.com/users/"+params.id, requestOptions)
               .then(res => res.json())
               .then((result)=>{
                console.log("public users", result.name)
                if(result.name === "BadRequest"){   
                    console.log("yes", result.name)
                    this.setState({
                                   lloadingnews  :true,
                                   check : true
                               }) 
                }else{

                    this.setState({
                        loadingnews :false,
                        public : result,
                        check : false
                    })
                    
                }
               })
               fetch("https://uvunebeta.herokuapp.com/payment?owner="+ params.id, requestOptions)
               .then(res => res.json())
               .then((result)=>{
                 if(result){
                    const tuitionData = result.data;
                    //const tuitionData = [];
                    const allCompletedTuitions = [];
                     tuitionData.forEach( (tuition, index) => {
                        console.log(`member --- ${index} =>`, tuition );
                        fetch("https://uvunebeta.herokuapp.com/tuition-category/"+ tuition.tuition_category_id, requestOptions)
                        .then(res => res.json())
                        .then((result)=>{
                            if(result){
                                console.log("category============ ", result)
                                let category = result;
                                
                                //tuitionCategory.push(result)
                                //console.log("data========== push", this.state.tuitionCategory)
    
                                let completeTuition = {
                                    ...tuition,
                                    category: {
                                        ...category
                                    }
                                }
    
                                console.log("complet tuition", completeTuition);
    
                                allCompletedTuitions.push(completeTuition);
                                // console.log("result payment", result.data)
                                this.setState({
                                    loadingedit:true,
                                    noticeshow : true,
                                    payments:allCompletedTuitions,
                                    loading:false
                                    //  check : false
                                })
                            }else{
                                this.setState({
                                    // loadingTuition :true
                                }) 
                            }
                        })
    
                     })
                     
                    //  this.getData(result)
                    
                 }else{
                    this.setState({
                        check : true
                    })
                 }
               }).catch( (error) => {
                 //  console.log("errro", error);
                  console.log("error load", "check", this.state.check )
             });

             fetch("https://uvunebeta.herokuapp.com/notifications?created_by="+ params.id, requestOptions)
             .then(res => res.json())
             .then((result)=>{
               if(result){
                   console.log("result notification", result.data)
                   this.setState({
                       loadingedit:true,
                       noticeshow : true,
                       notification:result.data,
                    //    check : false
                   })
                  //  this.getData(result)
                  
               }else{
                check : true
               }
             }).catch( (error) => {
               //  console.log("errro", error);
                console.log("error load", error )
           });
       } 

       renderValue() {
        let {value} = this.state;
        if(!value.length) return "Select..."
        else return value.join(', ')
}
           
       clickpick=(active , val)=>{
          console.log("active , val",active , val)
          let {value} = this.state;
        
          if(active) value = [...value, val]
          else value = value.filter(e => e != val);
          
          this.setState({value})
          console.log("state", this.state.value)
        //   this.props.clickpick(active , val)
       }

           
       closenav = (data)=>{
          console.log("data ---===---> ", data)
          this.props.closenav(data)
       }
       
  render() {

    
    
    return (
         
          
         
            <div className="public-body-container"> 
              <div class="header-me"  >
                  <h2>Guangdong</h2>
                 {/* <div style={{backgroundImage: "url(" + this.state.image + ")", "width": "81%",margin:"auto",height:"200px"}} ></div> */}
                 {/* <img src={this.state.image}  /> */}
              </div>
              <div style={{"z-index":"4000"}}>
              <Publicnav closenav={this.closenav} />
              </div>
            

             <div className="public-body-sidevan">
                <ul className="public-body-sidevan-list">
                    <li>
                    <i class="fas fa-comment-alt" style={{fontSize:"210%"}}></i>
                    <br/>
                    <p style={{fontSize:"70%"}}>Chat now</p>
                    </li>
                    <li>
                    <i class="fas fa-envelope" style={{fontSize:"210%"}}></i>
                    <br/>
                    <p style={{fontSize:"70%"}}>Leave Messages</p>
                    </li>
                </ul>
             </div>


             <div class="content" style={{width:"80%"}} >
                 <div className="publie-content-carousel">
                        <Carousel axis="vertical" showThumbs={false}>
                            <div className="publie-home-carousel-img">
                                <img src="https://www.obagi.com/sites/default/files/pro-c_family_shot_w_suncare_page1_transparent.png" />
                                <p className="legend">Legend 1</p>
                            </div>
                            <div className="publie-home-carousel-img">
                                <img src="https://www.amd.com/system/files/2019-06/238593-ryzen-5-pib-left-facing-1260x709.png" />
                                <p className="legend">Legend 2</p>
                            </div>
                            <div className="publie-home-carousel-img">                            
                                <img src="https://monatglobal.com/wp-content/uploads/2019/02/STUDIO-ONE-REFINISH-CONTROL-HAIRSPRAY-500x438.png" />
                                <p className="legend">Legend 3</p>
                            </div>
                        </Carousel>
                 </div>
                
                <div className="publie-content-adds">
                   <img src="https://res.cloudinary.com/easywaya/image/upload/v1535530819/uvunelogo2_ayfgrq.png"  width="50" style={{float:"left"}}/>     Join Uvune market palce today
                </div>
                <div className="publie-content-first-product">
                   <div className="publie-content-title-first">
                     <b> Last Update  </b> 
                   </div>

                   <div className="publie-content-image">
                   
                        <ul className="publie-content-image-li"> 
                            <li>
                                    <div className="publie-content-image-sub">
                                            <img src="https://natura.gfl.eu/content/files/images/c_the-natura/thererumnatura_16a.jpg" /> 
                                    </div>
                                    <div className="publie-content-item-name">
                                        Free Shipping TOPK AM60 1M 18W QC 3.0 Magnetic USB Cable
                                        <h3>$2.69 - $3.99</h3>
                                        <a class="button is-link is-rounded">Rounded</a>
                                    </div>
                             
                            </li>
                            <li>
                                 <div className="publie-content-image-sub">
                                            <img src="https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcRjofqmU_l-G6it6MgPt-1Gu6kfL4YJ7eROMEDBBdh3kN1K7icI" /> 
                                    </div>
                                    <div className="publie-content-item-name">
                                        Free Shipping TOPK AM60 1M 18W QC 3.0 Magnetic USB Cable
                                        <h3>$2.69 - $3.99</h3>
                                        <a class="button is-link is-rounded">Rounded</a>
                                    </div>
                             
                            </li>
                            <li>
                            
                            <div className="publie-content-image-sub">
                                            <img src="https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcSNzr-s9CPS69u5QDqsRmE20oPmkWT34Oz1CpHI9OpXQWmJbkwevA" /> 
                                    </div>
                                    <div className="publie-content-item-name">
                                        Free Shipping TOPK AM60 1M 18W QC 3.0 Magnetic USB Cable
                                        <h3>$2.69 - $3.99</h3>
                                        <a class="button is-link is-rounded">Rounded</a>
                                    </div>
                             
                            </li>
                            <li>
                            <div className="publie-content-image-sub">
                                            <img src="https://cdn11.bigcommerce.com/s-u6pyv0n7lf/content/home/tea-tree-special-shampoo-feature-banner-sep17-2.jpg" /> 
                                    </div>
                                    <div className="publie-content-item-name">
                                        Free Shipping TOPK AM60 1M 18W QC 3.0 Magnetic USB Cable
                                        <h3>$2.69 - $3.99</h3>
                                        <a class="button is-link is-rounded">Rounded</a>
                                    </div>
                                 
                               
                            </li>
                            <li>
                            
                            <div className="publie-content-image-sub">
                                            <img src="https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcRDzzfyfvAHv5OhLwCQ1tIkRQBRdBNnIrPkkcHTrYrjQ2s5KKsM" /> 
                                    </div>
                                    <div className="publie-content-item-name">
                                        Free Shipping TOPK AM60 1M 18W QC 3.0 Magnetic USB Cable
                                        <h3>$2.69 - $3.99</h3>
                                        <a class="button is-link is-rounded">Rounded</a>
                                    </div>
                            </li>
                            <li>
                            
                            <div className="publie-content-image-sub">
                                            <img src="https://d1ebdenobygu5e.cloudfront.net/media/catalog/product/cache/thumbnail/300x300/beff4985b56e3afdbeabfc89641a4582/h/g/hgc-front.jpg" /> 
                                    </div>
                                    <div className="publie-content-item-name">
                                        Free Shipping TOPK AM60 1M 18W QC 3.0 Magnetic USB Cable
                                        <h3>$2.69 - $3.99</h3>
                                        <a class="button is-link is-rounded">Rounded</a>
                                    </div>
                            </li>
                            <li>
                            
                            <div className="publie-content-image-sub">
                                            <img src="https://www.henkel.com/resource/image/199864/4x3/335/251/f213e247ccf8ef662fac50da01079af4/ap/product-assortment-adhesives.jpg" /> 
                                    </div>
                                    <div className="publie-content-item-name">
                                        Free Shipping TOPK AM60 1M 18W QC 3.0 Magnetic USB Cable
                                        <h3>$2.69 - $3.99</h3>
                                        <a class="button is-link is-rounded">Rounded</a>
                                    </div>
                            </li>

                            <li>
                            
                            <div className="publie-content-image-sub">
                                            <img src="https://www.charlottesweb.com/media/catalog/product/cache/1/small_image/480x/9df78eab33525d08d6e5fb8d27136e95/c/b/cbd-oil-max-strength.jpg" /> 
                                    </div>
                                    <div className="publie-content-item-name">
                                        Free Shipping TOPK AM60 1M 18W QC 3.0 Magnetic USB Cable
                                        <h3>$2.69 - $3.99</h3>
                                        <a class="button is-link is-rounded">Rounded</a>
                                    </div>
                            </li>

                            
                           
                        </ul>
                   </div>

                </div>
                <div className="publie-content-info-body">
                    <div class="columns">
                        <div class="column is-two-thirds">
                            <div class="columns">
                                <div class="column is-half">
                                    <div className="publie-content-info-logo">
                                       <img src="https://www.seoclerk.com/pics/551103-1TOqFD1502285018.jpg"  />
                                    </div>
                                 
                                </div>
                                <div class="column">
                                    <div className="publie-content-info-sub">
                                          topko
                                        <hr style={{background:"white"}} />
                                        kdgnkjdnlkjs
                                        <hr style={{background:"white"}} />
                                        kdgnkjdnlkjs
                                        <hr style={{background:"white"}} />
                                    </div>
                                </div>
                                
                            </div>
                        </div>
                        <div class="column">
                             <div className="publie-content-info-contact">
                                 <ul className="publie-content-info-list">
                                     <li>
                                     <i class="fas fa-comment-alt" style={{fontSize:"210%"}}></i>
                                     <br/>
                                      <p style={{fontSize:"70%"}}>Chat now</p>
                                     </li>
                                     <li>
                                     <i class="fas fa-envelope" style={{fontSize:"210%"}}></i>
                                     <br/>
                                     <p style={{fontSize:"70%"}}>Leave Messages</p>
                                     </li>
                                 </ul>
                             </div>
                        </div>          
                    </div>

                </div>
                <div className="publie-content-first-product">
                   <div className="publie-content-title-first">
                     <b> All Product </b> 
                   </div>

                   <div className="publie-content-image">
                   
                        <ul className="publie-content-image-li"> 
                            <li>
                                    <div className="publie-content-image-sub">
                                            <img src="https://natura.gfl.eu/content/files/images/c_the-natura/thererumnatura_16a.jpg" /> 
                                    </div>
                                    <div className="publie-content-item-name">
                                        Free Shipping TOPK AM60 1M 18W QC 3.0 Magnetic USB Cable
                                        <h3>$2.69 - $3.99</h3>
                                        <a class="button is-link is-rounded">Rounded</a>
                                    </div>
                             
                            </li>
                            <li>
                                 <div className="publie-content-image-sub">
                                            <img src="https://natura.gfl.eu/content/files/images/c_the-natura/thererumnatura_16a.jpg" /> 
                                    </div>
                                    <div className="publie-content-item-name">
                                        Free Shipping TOPK AM60 1M 18W QC 3.0 Magnetic USB Cable
                                        <h3>$2.69 - $3.99</h3>
                                        <a class="button is-link is-rounded">Rounded</a>
                                    </div>
                             
                            </li>
                            <li>
                            
                            <div className="publie-content-image-sub">
                                            <img src="https://natura.gfl.eu/content/files/images/c_the-natura/thererumnatura_16a.jpg" /> 
                                    </div>
                                    <div className="publie-content-item-name">
                                        Free Shipping TOPK AM60 1M 18W QC 3.0 Magnetic USB Cable
                                        <h3>$2.69 - $3.99</h3>
                                        <a class="button is-link is-rounded">Rounded</a>
                                    </div>
                             
                            </li>
                            <li>
                            <div className="publie-content-image-sub">
                                            <img src="https://natura.gfl.eu/content/files/images/c_the-natura/thererumnatura_16a.jpg" /> 
                                    </div>
                                    <div className="publie-content-item-name">
                                        Free Shipping TOPK AM60 1M 18W QC 3.0 Magnetic USB Cable
                                        <h3>$2.69 - $3.99</h3>
                                        <a class="button is-link is-rounded">Rounded</a>
                                    </div>
                                 
                               
                            </li>
                            <li>
                            
                            <div className="publie-content-image-sub">
                                            <img src="https://natura.gfl.eu/content/files/images/c_the-natura/thererumnatura_16a.jpg" /> 
                                    </div>
                                    <div className="publie-content-item-name">
                                        Free Shipping TOPK AM60 1M 18W QC 3.0 Magnetic USB Cable
                                        <h3>$2.69 - $3.99</h3>
                                        <a class="button is-link is-rounded">Rounded</a>
                                    </div>
                            </li>
                            <li>
                            
                            <div className="publie-content-image-sub">
                                            <img src="https://natura.gfl.eu/content/files/images/c_the-natura/thererumnatura_16a.jpg" /> 
                                    </div>
                                    <div className="publie-content-item-name">
                                        Free Shipping TOPK AM60 1M 18W QC 3.0 Magnetic USB Cable
                                        <h3>$2.69 - $3.99</h3>
                                        <a class="button is-link is-rounded">Rounded</a>
                                    </div>
                            </li>
                            <li>
                            
                            <div className="publie-content-image-sub">
                                            <img src="https://natura.gfl.eu/content/files/images/c_the-natura/thererumnatura_16a.jpg" /> 
                                    </div>
                                    <div className="publie-content-item-name">
                                        Free Shipping TOPK AM60 1M 18W QC 3.0 Magnetic USB Cable
                                        <h3>$2.69 - $3.99</h3>
                                        <a class="button is-link is-rounded">Rounded</a>
                                    </div>
                            </li>

                            
                           
                        </ul>
                   </div>

                </div>
                 <div className="publie-content-fooler-body">
                    <div class="content has-text-centered">
                                    <p>
                                    <strong>Bulma</strong> by <a href="https://jgthms.com">Jeremy Thomas</a>. The source code is licensed
                                    <a href="http://opensource.org/licenses/mit-license.php">MIT</a>. The website content
                                    is licensed <a href="http://creativecommons.org/licenses/by-nc-sa/4.0/">CC BY NC SA 4.0</a>.
                                    </p>
                         </div>

                    </div>
           
             </div>
              
              </div> 

    )

}





}

export default Public;


// WEBPACK FOOTER //
// ./src/component/public/public.js